import React from "react";
import "./CalendarContent.css";
import { formatTimeStamp } from "../../../../../shared/dateFormat";
export default function CalendarContent(props) {
  const { diary } = props;
  return (
    <div className={"p-2 flex-box"}>
      <div className={"pr-1 pl-1"}>{formatTimeStamp(diary.startTime)}</div>
      <div className={"p-2 bg-color-pale-blue w-100"}>
        <div className={"calendar-content-title"}>{diary.location} </div>
        <div className={"calendar-content-details"}>{diary.description}</div>
      </div>
    </div>
  );
}
